"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeSearchStage = void 0;
exports.isHomeSearchStage = isHomeSearchStage;
/**
 * @TranslateToPython
 * Where the applicant says they are in the home-buying process, asked on the first-lien-purchase welcome step.
 * This is self-reported intent for funnel segmentation, not a lifecycle status of the application itself.
 */
var HomeSearchStage;
(function (HomeSearchStage) {
    HomeSearchStage["thinkingAboutBuying"] = "thinkingAboutBuying";
    HomeSearchStage["activelyLooking"] = "activelyLooking";
    HomeSearchStage["makingOffers"] = "makingOffers";
    HomeSearchStage["purchaseAgreementSigned"] = "purchaseAgreementSigned";
})(HomeSearchStage || (exports.HomeSearchStage = HomeSearchStage = {}));
function isHomeSearchStage(value) {
    return Object.values(HomeSearchStage).includes(value);
}
